import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

const STORAGE_KEY = "dashboard-next.post-login-redirect";

@Injectable({ providedIn: "root" })
export class PostLoginRedirectService {
    private readonly router = inject(Router);

    remember(url: string): string | null {
        const safe = this.sanitize(url);
        if (safe) sessionStorage.setItem(STORAGE_KEY, safe);
        return safe;
    }

    rememberFromLoginUrl(url: string): void {
        const value = this.router.parseUrl(url).queryParams["redirectUrl"];
        if (typeof value === "string") this.remember(value);
    }

    consume(loginUrl: string): string | null {
        const queryValue =
            this.router.parseUrl(loginUrl).queryParams["redirectUrl"];
        const candidate =
            typeof queryValue === "string"
                ? queryValue
                : sessionStorage.getItem(STORAGE_KEY);
        sessionStorage.removeItem(STORAGE_KEY);
        return candidate ? this.sanitize(candidate) : null;
    }

    clear(): void {
        sessionStorage.removeItem(STORAGE_KEY);
    }

    private sanitize(url: string): string | null {
        if (!url.startsWith("/") || url.startsWith("//") || url.includes("\\"))
            return null;
        try {
            const tree = this.router.parseUrl(url);
            const root = tree.root.children["primary"]?.segments[0]?.path ?? "";
            if (
                ["login", "register", "forgot-password", "azure"].includes(root)
            )
                return null;
            return this.router.serializeUrl(tree);
        } catch {
            return null;
        }
    }
}
